import validator from 'lib/validator';
import { mergeSchemas } from 'lib/validator';

export const minLength8 = validator.string().min(8);

export const minLength16 = validator.string().min(16);

export const containsNumbers = validator
  .string()
  .matches(/[0-9]/, 'password must contain number');

export const containsLowerCaseAlphas = validator
  .string()
  .matches(/[a-z]/, 'password must contain lower case alphabet');

export const containsUpperCaseAlphas = validator
  .string()
  .matches(/[A-Z]/, 'password must contain upper case alphabet');

export const containsSpecialChars = validator
  .string()
  .matches(
    /[@#$%^&*()_+|~\-=\\`{}\[\]:";'<>\/!]/,
    'password must contain special character',
  );

export const adminPasswordSchema = mergeSchemas(
  minLength16,
  containsNumbers,
  containsLowerCaseAlphas,
  containsUpperCaseAlphas,
  containsSpecialChars,
);
